import * as React from "react";

import AppModals from "@editor/components/AppModals";

import { Outlet } from "react-router-dom";

import PreviewNavbar from "../components/navbar/PreviewNavbar";

export default function CanvasLayout() {
  return (
    <div className="flex h-screen flex-col">
      <div className="w-full h-full flex flex-col bg-white p-3 pb-0 overflow-hidden">
        <div className="flex flex-col gap-3 w-full h-full">
          <PreviewNavbar />
          <div className="flex-1 min-h-0">
            <AppModals />
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
